package com.havn.app.core.di

import com.havn.app.core.supabase.SupabaseClientProvider
import com.havn.app.core.billing.HavnBillingService
import com.havn.app.core.billing.createHavnBillingService
import com.havn.app.core.localization.HavnLanguageRepository
import com.havn.app.core.settings.HavnUnitPreferencesRepository
import com.havn.app.core.settings.HavnKioskSecurityRepository
import com.havn.app.ui.theme.HavnThemeManager
import com.havn.app.features.agency.data.SupabaseAgencyRepository
import com.havn.app.features.agency.domain.AgencyRepository
import com.havn.app.features.analytics.data.SupabaseAnalyticsAiService
import com.havn.app.features.analytics.domain.AnalyticsAiService
import com.havn.app.features.attachments.data.SupabaseAttachmentRepository
import com.havn.app.features.attachments.domain.AttachmentRepository
import com.havn.app.features.auth.data.SupabaseAuthRepository
import com.havn.app.features.auth.domain.AuthRepository
import com.havn.app.features.clients.data.SupabaseClientRepository
import com.havn.app.features.clients.domain.ClientRepository
import com.havn.app.features.followups.data.SupabaseAiFollowUpService
import com.havn.app.features.followups.data.SupabaseFollowUpRepository
import com.havn.app.features.followups.domain.AiFollowUpService
import com.havn.app.features.followups.domain.FollowUpRepository
import com.havn.app.features.leads.data.SupabaseLeadRepository
import com.havn.app.features.leads.domain.LeadRepository
import com.havn.app.features.openhouses.data.SupabaseOpenHouseRepository
import com.havn.app.features.openhouses.domain.OpenHouseRepository
import com.havn.app.features.notifications.data.SupabaseNotificationRepository
import com.havn.app.features.notifications.domain.NotificationRepository
import com.havn.app.features.properties.data.SupabasePropertyRepository
import com.havn.app.features.properties.domain.PropertyRepository
import com.havn.app.features.reports.data.SupabaseSellerReportRepository
import com.havn.app.features.reports.data.SupabaseSellerReportAiService
import com.havn.app.features.reports.domain.SellerReportAiService
import com.havn.app.features.reports.domain.SellerReportRepository
import com.havn.app.features.settings.data.SupabaseMcpApiKeyRepository
import com.havn.app.features.settings.domain.McpApiKeyRepository
import com.havn.app.features.tasks.data.SupabaseHavnTaskRepository
import com.havn.app.features.tasks.domain.HavnTaskRepository

class AppContainer(
    val authRepository: AuthRepository,
    val propertyRepository: PropertyRepository,
    val openHouseRepository: OpenHouseRepository,
    val clientRepository: ClientRepository,
    val leadRepository: LeadRepository,
    val followUpRepository: FollowUpRepository,
    val aiFollowUpService: AiFollowUpService,
    val sellerReportRepository: SellerReportRepository,
    val sellerReportAiService: SellerReportAiService,
    val analyticsAiService: AnalyticsAiService,
    val taskRepository: HavnTaskRepository,
    val attachmentRepository: AttachmentRepository,
    val agencyRepository: AgencyRepository,
    val mcpApiKeyRepository: McpApiKeyRepository,
    val notificationRepository: NotificationRepository,
    val languageRepository: HavnLanguageRepository,
    val unitPreferencesRepository: HavnUnitPreferencesRepository,
    val kioskSecurityRepository: HavnKioskSecurityRepository,
    val themeManager: HavnThemeManager,
    val billingService: HavnBillingService
) {
    companion object {
        fun default(): AppContainer {
            return AppContainer(
                authRepository = SupabaseAuthRepository(SupabaseClientProvider.client),
                propertyRepository = SupabasePropertyRepository(SupabaseClientProvider.client),
                openHouseRepository = SupabaseOpenHouseRepository(SupabaseClientProvider.client),
                clientRepository = SupabaseClientRepository(SupabaseClientProvider.client),
                leadRepository = SupabaseLeadRepository(SupabaseClientProvider.client),
                followUpRepository = SupabaseFollowUpRepository(SupabaseClientProvider.client),
                aiFollowUpService = SupabaseAiFollowUpService(SupabaseClientProvider.client),
                sellerReportRepository = SupabaseSellerReportRepository(SupabaseClientProvider.client),
                sellerReportAiService = SupabaseSellerReportAiService(SupabaseClientProvider.client),
                analyticsAiService = SupabaseAnalyticsAiService(SupabaseClientProvider.client),
                taskRepository = SupabaseHavnTaskRepository(SupabaseClientProvider.client),
                attachmentRepository = SupabaseAttachmentRepository(SupabaseClientProvider.client),
                agencyRepository = SupabaseAgencyRepository(SupabaseClientProvider.client),
                mcpApiKeyRepository = SupabaseMcpApiKeyRepository(SupabaseClientProvider.client),
                notificationRepository = SupabaseNotificationRepository(SupabaseClientProvider.client),
                languageRepository = HavnLanguageRepository(),
                unitPreferencesRepository = HavnUnitPreferencesRepository(),
                kioskSecurityRepository = HavnKioskSecurityRepository(),
                themeManager = HavnThemeManager(),
                billingService = createHavnBillingService()
            )
        }
    }
}
